import request from '@/utils/request'

export function upload(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/common/upload',
    method: 'post',
    data
  })
}

export function uploadBase64(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/common/uploadBase64',
    method: 'post',
    data
  })
}
